import TransitApi from './base'

export default {
  // TODO: Add search, filters and sort params
  async getAll(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/user/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getById(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/user/details/${params.id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getRoles() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/role/list')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/user/details/${params.id}` : '/user/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async disable(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = `/user/disable/${params.id}`
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },
}
